import { connect as formikConnect } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';

import { createBEM } from '../../../lib/utils/css';

import * as FormUtils from './utils';

import './FormItemGroup.scss';

/**
 * @param  {string} legend - Text on top of the inputs
 * @param  {string} description - Hidden description for screen reader
 * @param  {Any} children - FormItem
 * @param  {Any} formik - Provided by formik connect
 */

class FormItemGroup extends React.Component {
  static propTypes = {
    theme: PropTypes.string,
    legend: PropTypes.string,
    description: PropTypes.string,
    children: PropTypes.any,
    formik: PropTypes.object,
  };

  hasError = () => {
    const { children, formik } = this.props;
    const childrenNames = React.Children.map(children, element => {
      return element.props.inputAttributes ? element.props.inputAttributes.name : null;
    });
    const hasErrorSelectArray = [];
    childrenNames.forEach(name => {
      hasErrorSelectArray.push(FormUtils.shouldShowError(formik, name));
    });
    return hasErrorSelectArray.includes(true);
  };

  renderLegend = () => {
    return (
      <legend className='FormItemGroup__legend'>
        <div className='FormItemGroup__title'>{this.props.legend}</div>
        <span className='a11y--visuallyHidden'>{this.props.description}</span>
      </legend>
    );
  };

  render() {
    const { theme, legend, children } = this.props;
    const formItemGroupClasses = createBEM('FormItemGroup', {
      [theme]: !!theme,
      error: this.hasError(),
    });
    return (
      <div className={formItemGroupClasses}>
        {legend && this.renderLegend()}
        <div className='FormItemGroup__content'>
          {React.Children.map(children, (child, index) => {
            return React.cloneElement(child, { index, theme });
          })}
        </div>
      </div>
    );
  }
}

export default formikConnect(FormItemGroup);
